import { htmlEncode } from "./htmlEncode";

export const quoteStringDoubleVertical = (value: string) => `"${value.replaceAll('"', '\\"')}"` as const;
export type QuotedStringDoubleVertical = ReturnType<typeof quoteStringDoubleVertical>;

export const quoteStringDoubleVerticalHtml = (value: string) => `"${htmlEncode(value)}"` as const;
export type QuotedStringDoubleVerticalHtml = ReturnType<typeof quoteStringDoubleVertical>;

export const quoteStringDoubleCurly = (value: string) => `“${value}”` as const;
export type QuotedStringDoubleCurly = ReturnType<typeof quoteStringDoubleCurly>;

export const quoteStringDoubleCurlyHtml = (value: string) => `“${htmlEncode(value)}”` as const;
export type QuotedStringDoubleCurlyHtml = ReturnType<typeof quoteStringDoubleCurly>;
